import React, { useState } from "react";
import { auth, provider, signInWithPopup, firestoreDB, doc, getDoc } from "../firebase";
import "./MainScreen.css";

function MainScreen({ onAdminAuthorized }) {
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState("about");

  const email = "menarate@menaratenggara.com";
  const subject = "Inquiry";

  const [menuOpen, setMenuOpen] = useState(false);

  const handleEmailClick = (e) => {
    e.preventDefault();

    const mailtoHref = `mailto:${email}?subject=${encodeURIComponent(subject)}`;

    // Copy to clipboard
    if (navigator.clipboard) {
      navigator.clipboard.writeText(email)
        .then(() => console.log("Email copied to clipboard"))
        .catch(() => console.warn("Clipboard copy failed"));
    }

    // Detect desktop vs mobile
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // Use mailto for mobile
      window.location.href = mailtoHref;
    } else {
      // Open Gmail compose in new tab for desktop
      const gmailHref = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}`;
      window.open(gmailHref, "_blank");
      alert("Email link opened Gmail in a new tab. Your email was also copied to clipboard.");
    }
  };

  const handleAdminLogin = async () => {
    try {
      setLoading(true);

      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const email = user?.email;

      if (!email) {
        alert("Login failed. No email found.");
        return;
      }

      const docRef = doc(firestoreDB, "Admins", "profile");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const staffEmails = Array.isArray(data.staffEmails) ? data.staffEmails : [];

        if (staffEmails.includes(email)) {
          onAdminAuthorized(email);
        } else {
          alert("Access denied. You are not an authorized admin.");
          await auth.signOut();
        }
      } else {
        alert("Admin profile document not found.");
      }
    } catch (error) {
      console.error(error);
      alert("Google Sign-In failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-root">

      {/* ===== HEADER ===== */}
      <header className="header">
        <div className="header-left">
          <img
            src={process.env.PUBLIC_URL + "/assets/menara_tenggara.png"}
            alt="Logo"
            className="header-logo"
          />
          <h1>Menara Tenggara Enterprise</h1>
        </div>

        {/* ===== NAV MENU ===== */}
        <div className={`nav-menu ${menuOpen ? "open" : ""}`}>
          <button
            className={activeSection === "about" ? "active" : ""}
            onClick={() => setActiveSection("about")}
          >
            About
          </button>

          <button
            className={activeSection === "location" ? "active" : ""}
            onClick={() => setActiveSection("location")}
          >
            Location
          </button>

          <button
            className={activeSection === "contact" ? "active" : ""}
            onClick={() => setActiveSection("contact")}
          >
            Contact Us
          </button>
        </div>

        <button className="btn google header-login" onClick={handleAdminLogin}>
          <img
            src={process.env.PUBLIC_URL + "/assets/google.png"}
            alt="Google"
            className="google-icon"
          />
          Admin Login
        </button>

        <button 
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </header>

      {/* ===== CONTENT ===== */}
      <main className="content">

        {/* ===== ABOUT ===== */}
        {activeSection === "about" && (
          <>
            <h2>About Menara Tenggara Enterprise</h2>

            <p className="summary">
              Menara Tenggara Enterprise is a bumiputra status company and has been
              operating since 1997. We are a sub-vendor for Sapura Machining
              Corporation Sdn Bhd and LSF Technology Sdn Bhd which provide automotive
              component painting services for PERODUA, HONDA, MAZDA, and TOYOTA cars.
              We have been recognized by SIRIM with ISO 9001:2015 certification since 2013.
            </p>

            <div className="image-row">
              <img src={process.env.PUBLIC_URL + "/assets/img1.jpg"} alt="Factory 1" />
              <img src={process.env.PUBLIC_URL + "/assets/img2.jpg"} alt="Factory 2" />
              <img src={process.env.PUBLIC_URL + "/assets/img3.jpg"} alt="Factory 3" />
            </div>
          </>
        )}

        {/* ===== LOCATION ===== */}
        {activeSection === "location" && (
          <div className="location-container">
            <div className="location-box">
              <h2>Our Location</h2>

              <p>
                Jalan Nilai 7/10 487, Nilai, Negeri Sembilan, Malaysia
              </p>

              <iframe
                title="map"
                src="https://www.google.com/maps?q=197%2C+Jalan+Nilai+7%2F11%2C+Nilai&output=embed"
                className="location-map"
              ></iframe>
            </div>
          </div>
        )}

        {/* ===== CONTACT ===== */}
        {activeSection === "contact" && (
          <div className="contact-container">
            <div className="contact-box">
              <h2>Contact Us</h2>

              <p><strong>Phone:</strong> 06-794 1223</p>

              <p>
                <strong>Email:</strong>{" "}
                {/* ⚡ Fixed: Used contextual fallback mailto path instead of raw empty string "#" */}
                <a
                  href={`mailto:${email}?subject=${encodeURIComponent(subject)}`}
                  className="address-link"
                  onClick={handleEmailClick}
                >
                  {email}
                </a>
              </p>

              <div className="operation-hours">
                <h3>Operation Time</h3>

                <p><strong>Monday to Thursday</strong></p>
                <p>9:00 am – 1:00 pm</p>
                <p>2:00 pm – 5:30 pm</p>

                <p style={{ marginTop: "10px" }}><strong>Friday</strong></p>
                <p>9:00 am – 12:30 pm</p>
                <p>2:30 pm – 5:30 pm</p>
              </div>
            </div>
          </div>
        )}
      </main>

      {/* ===== FOOTER ===== */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Menara Tenggara Enterprise</p>
      </footer>

      {/* ===== LOADER ===== */}
      {loading && (
        <div className="overlay">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
}

export default MainScreen;